'use strict';

/*global ga*/
if (typeof window.tom == 'undefined') window.tom = {};
if (typeof window.tom.conf == 'undefined') window.tom.conf = {};
if (typeof window.tom.fb == 'undefined') window.tom.fb = {};
if (typeof window.tom.tw == 'undefined') window.tom.tw = {};
if (typeof window.tom.reddit == 'undefined') window.tom.reddit = {};
if (typeof window.tom.helper == 'undefined') window.tom.helper = {};
if (typeof window.tom.i18n == 'undefined') window.tom.i18n = {};
if (typeof window.tom.user == 'undefined') window.tom.user = {};

window.tom.i18n = (function () {
  var dic = {
    '#news_category-ALL': 'ALL',
    '#news_category-FEATURED': 'FEATURED',
    '#news_category-ANIME': 'ANIME',
    '#news_category-ART': 'ART',
    '#news_category-COSPLAY': 'COSPLAY',
    '#news_category-EVENT': 'EVENT',
    '#news_category-FIGURE': 'FIGURE',
    '#news_category-JAPAN': 'JAPAN',
    '#news_category-HOW_TO': 'HOW TO',
    '#news_category-GAME': 'GAME',
    '#news_category-MANGA': 'MANGA',
    '#news_category-MOVIE': 'MOVIE',
    '#news_category-MUSIC': 'MUSIC',
    '#news_category-FASHION': 'FASHION',
    '#news_category-PRODUCT': 'PRODUCT',
    '#news_category-PRESS_RELEASE': 'PRESS RELEASE'
  };

  return {
    __: function (key) {
      return 'undefined' == typeof dic[key] ? key : dic[key];
    }
  };
})();

tom.fb.share = function (url, category, action, label) {
  tom.helper.ga.push(['event', category, action, label, 1]);
  var w = 640;
  var h = 480;
  var ws = window.screen;
  var sTop = ws.height / 2 - h / 2;
  var sLeft = ws.width / 2 - w / 2;
  window.open(
    'https://www.facebook.com/sharer/sharer.php?u=' + url,
    'FbShare',
    'status=1,height=' +
      h +
      ',width=' +
      w +
      ',top=' +
      sTop +
      ',left=' +
      sLeft +
      ',resizable=0'
  );
};

tom.tw.share = function (url, category, action, label, options) {
  options = options || {};
  tom.helper.ga.push(['event', category, action, label, 1]);
  var w = 640;
  var h = 270;
  var ws = window.screen;
  var sTop = ws.height / 2 - h / 2;
  var sLeft = ws.width / 2 - w / 2;
  var twitterUrl = 'https://twitter.com/intent/tweet?url=' + url;
  if (typeof options.text !== 'undefined') {
    twitterUrl += '&text=' + options.text;
  }
  if (typeof options.via !== 'undefined') {
    twitterUrl += '&via=' + options.via;
  }
  if (typeof options.related !== 'undefined') {
    twitterUrl += '&related=' + options.related;
  }
  if (typeof options.hashtags !== 'undefined') {
    twitterUrl += '&hashtags=' + options.hashtags;
  }

  window.open(
    twitterUrl,
    'TwShare',
    'status=1,height=' +
      h +
      ',width=' +
      w +
      ',top=' +
      sTop +
      ',left=' +
      sLeft +
      ',resizable=0'
  );
};

tom.reddit.share = function (url, category, action, label, options) {
  tom.helper.ga.push(['event', category, action, label, 1]);
  var w = 640;
  var h = 600;
  var ws = window.screen;
  var sTop = ws.height / 2 - h / 2;
  var sLeft = ws.width / 2 - w / 2;
  var redditUrl = 'https://reddit.com/submit?url=' + url;
  if (typeof options.title !== 'undefined') {
    redditUrl += '&title=' + options.title;
  }
  window.open(
    redditUrl,
    'RedditShare',
    'status=1,height=' +
      h +
      ',width=' +
      w +
      ',top=' +
      sTop +
      ',left=' +
      sLeft +
      ',resizable=0'
  );
};

tom.helper.disableDrag = function (selector) {
  if (selector) {
    $(document)
      .on('mousedown', selector, function () {
        return false;
      })
      .on('mouseup', selector, function () {
        return false;
      })
      .on('mouseover', selector, function () {
        return false;
      })
      .on('drag', selector, function () {
        return false;
      })
      .on('dragstart', selector, function () {
        return false;
      })
      .on('dragend', selector, function () {
        return false;
      });
  }
};

tom.helper.draggable = function () {
  if ((window.location.search || '').indexOf('draggable=1') > -1) {
    $('img.nodraggable').removeClass('nodraggable');
    $('a').each(function () {
      var href = $(this).attr('href');
      if (href.indexOf('draggable=1') > -1) return;
      if (href.indexOf('?') > -1) {
        $(this).attr('href', href + '&draggable=1');
      } else {
        $(this).attr('href', href + '?draggable=1');
      }
    });
  }
};

tom.helper.trackAction = function (category, label, action, value, options) {
  if (!category || !label || !action) {
    return;
  }
  value = value || 1;
  options = options || {};

  var data = {
    _csrf: tom.conf.csrfToken,
    category: category,
    label: label,
    action: action,
    value: value,
    options: options
  };

  var url = '/api/track/action';
  if (options.ssl) {
    url += '?tom_landing=facebook';
  }
  $.ajax({
    dataType: 'json',
    type: 'POST',
    url: url,
    data: data,
    success: function () {},
    error: function () {}
  });
};

tom.helper.ajaxLoad = function (url, data, dataType, type, isCrossDomain) {
  var defer = jQuery.Deferred();
  var ajaxData = {
    url: url ? url : null,
    data: data ? data : {},
    dataType: dataType ? dataType : 'json',
    type: type ? type : 'post',
    success: defer.resolve,
    error: defer.reject
  };
  if (isCrossDomain === true) {
    ajaxData.url = tom.conf.sslUrl + ajaxData.url.replace(/^\//, '');
    ajaxData.data.format = 'json';
    ajaxData.xhrFields = { withCredentials: true };
    ajaxData.crossDomain = true;
  }
  jQuery.ajax(ajaxData);
  return defer.promise();
};

tom.helper.product = {
  // 商品リストの商品がクリックされた際にカートに追加する
  addToCart: function ($el, isCrossDomain, options) {
    var w = window;
    var TOM = tom;
    var product_id = $el.attr ? $el.attr('data-product-id') : $el.productId;
    var sku_id = $el.attr ? $el.attr('data-sku-id') : $el.skuId;
    var wishlistId = $el.attr ? $el.attr('data-wishlist-id') : $el.wishlistId;

    TOM.helper
      .ajaxLoad(
        '/cart/add',
        {
          sku_id: sku_id,
          product_id: product_id,
          wishlist_id: wishlistId,
          format: 'json'
        },
        'json',
        'get',
        isCrossDomain
      )
      .done(function (response) {
        if (response.additionSuccess) {
          if (wishlistId) {
            window.location.href = '/cart?wl=' + wishlistId;
          } else {
            window.location.href = '/cart';
          }
        } else {
          tom.helper.product.showModalOverMaxPurchaseQty();
        }
      })
      .fail(function () {
        w.location.href = '/shop/' + product_id;
      });

    tom.helper.ga.push([
      'event',
      options && options.gaCategoryName ? options.gaCategoryName : 'EC',
      options && options.gaActionName
        ? options.gaActionName
        : 'Add to Cart from List',
      sku_id,
      1
    ]);

    tom.helper.ga.addToCart(
      (options && options.gaProductData) || {
        id: sku_id,
        dimension1: tom.conf.isLogin ? 'Member' : 'Guest'
      }
    );

    return this;
  },

  // 購入個数制限超過アラートモーダル
  showModalOverMaxPurchaseQty: function (options) {
    var modalHtml;
    if (options && options.isPointsRedemption) {
      modalHtml =
        '<div data-remodal-id="modal-over-max-purchase-qty"><div class="u-fs-lg u-weight-bold">You’ve reached the max order limit for this product.</div><button class="c-btn c-btn--primary u-mtm" data-remodal-action="cancel">OK</button></div>';
    } else {
      modalHtml =
        '<div data-remodal-id="modal-over-max-purchase-qty"><div class="u-fs-lg u-weight-bold">You’ve reached the max order limit for this product.</div><div class="u-fs-md u-mts">No more can be added to your cart.</div><button class="c-btn c-btn--primary u-mtm" data-remodal-action="cancel">OK</button></div>';
    }
    $('body').append(modalHtml);
    $('[data-remodal-id=modal-over-max-purchase-qty]')
      .remodal({
        hashTracking: false,
        closeOnEscape: true,
        closeOnOutsideClick: true
      })
      .open();
  },

  addToWishlist: function ($el, $wishlistBtn) {
    var w = window;
    var productId = $el.attr('data-product-id');
    var skuId = $el.attr('data-sku-id');
    var wishlistModalBus = w.vueEventBus && w.vueEventBus.wishlistModal;

    if ($wishlistBtn.length <= 0) {
      return;
    }

    if (!tom.conf.isLogin) {
      w.location.href = '/login?r=' + encodeURIComponent(w.location.href);
      return;
    }

    wishlistModalBus.$emit('addToWishlists', {
      productId: productId,
      skuId: skuId
    });

    wishlistModalBus
      .$off('closeWishlistModal')
      .$on('closeWishlistModal', function (data) {
        if (data.isInWishlist) {
          if ($wishlistBtn.hasClass('added') && !$wishlistBtn.hasClass('in')) {
            $wishlistBtn
              .removeClass('removed')
              .addClass('added')
              .attr('title', w.tom.i18n.__('Added to Favorites'));
          } else {
            $wishlistBtn
              .removeClass('removed in')
              .addClass('added in')
              .attr('title', w.tom.i18n.__('Added to Favorites'));
          }
        } else {
          if ($wishlistBtn.hasClass('added')) {
            $wishlistBtn
              .removeClass('added in')
              .addClass('removed in')
              .attr('title', w.tom.i18n.__('Add to Favorites'));
          }
        }
      });
  },

  // Add to Cartボタンクリック処理を有効にする
  // Add to Favoritesボタンクリック処理を有効にする
  // isOutOfStockフラグが立っているものを売り切れ表示に切り替える
  // Wish Listに登録されているものは登録済み表示にする
  // ImpressionをGAに送信する
  productProperties: function ($wapper, parfix, callback, isCrossDomain) {
    var $products = $wapper.find('.js-productListItem');
    if (!$products.length) return this;
    $products.each(function () {
      var $product = $(this);
      $product.find('.js-addToWishlistFromList').on('click', function () {
        window.tom.helper.product.addToWishlist($product, $(this));
        return false;
      });
    });

    // impressionを送信
    if (!$wapper.hasClass('js-product-slider-list')) {
      tom.helper.ga.list.impression($products);
    }

    var ids = $.map($products, function (elm) {
      return $(elm).attr('data-product-id');
    });
    if (ids.length > 0) {
      tom.helper
        .ajaxLoad(
          '/shop/product_properties',
          {
            ids: ids,
            _csrf: $("meta[name='csrf-token']").attr('content')
          },
          'json',
          'POST',
          isCrossDomain
        )
        .done(function (response) {
          if (!parfix) parfix = '#';
          if (callback && typeof callback === 'function') {
            callback(response, parfix);
          } else {
            Object.keys(response).forEach(function (key) {
              if (response[key]) {
                var $target = $wapper.find(parfix + key);
                if (response[key].isOutOfStock) {
                  var outOfStockClassName = 'c-label--outofstock';
                  var outOfStockLabelText = 'Out of Stock';

                  if (response[key].discontinued) {
                    outOfStockClassName = 'c-label--discontinued';
                    outOfStockLabelText = 'Sold Out';
                  }

                  // OOSはItem Bonus表示しない
                  $target.find('.p-point__bonus-point').remove();
                  // New 表記を削除
                  $target.removeClass('p-product-list__item--new');
                  // 併記させないラベルは削除し、売り切れラベルを追加
                  $target.find('.js-productPropertyLabel').remove();
                  $('<span />')
                    .addClass(
                      'c-label c-label--sm js-productPropertyLabel ' +
                        outOfStockClassName
                    )
                    .text(outOfStockLabelText)
                    .appendTo($target.find('.js-productListItemLabels'));
                }
                if (response[key].isAddedToWishlist) {
                  $target
                    .find('.js-addToWishlistFromList')
                    .addClass('added')
                    .attr(
                      'data-tooltip',
                      window.tom.i18n.__('Added to Favorites')
                    );
                }
              }
            });
          }
        })
        .fail(function () {
          // console.log(arguments)
        });
    }
    return this;
  },

  enableProductBoxSlider: function ($area, options) {
    if (!$area) {
      $area = $('#contents');
    } else {
      $area = $area instanceof jQuery === true ? $area : jQuery($area);
    }

    if ($area.length) {
      $area.find('.js-product-slider-list').each(function (i, elm) {
        var $sliderBox = $(elm);
        var columns = $sliderBox.data('columns') || 4;
        // check sold out
        window.tom.helper.product.productProperties(
          $sliderBox,
          $sliderBox.data('prefix'),
          null,
          document.location.protocol === 'https:'
        );
        $sliderBox.removeAttr('data-prefix');

        var $children = $sliderBox.children();
        var sendImpression = function (index) {
          var items = [];
          for (var i = index; i < index + columns; i++) {
            var object = null;
            var json = $children.eq(i).attr('data-impression');
            if (json) {
              try {
                object = JSON.parse(json);
              } catch (e) {
                // do nothing
              }
            }
            if (object) {
              items.push(object);
            }
          }
          tom.helper.ga.list.impression(items);
        };

        sendImpression(0);

        if ($.isFunction($sliderBox.slick)) {
          $sliderBox
            .slick({
              slidesToShow: columns,
              slidesToScroll: columns,
              infinite: false,
              lazyLoad: options && options.lazyLoad ? 'ondemand' : 'linear',
              prevArrow:
                '<button type="button" class="slick-prev p-product-slider__prev">Previous</button>',
              nextArrow:
                '<button type="button" class="slick-next p-product-slider__next">Next</button>'
            })
            .on('afterChange', function (event, slick, currentSlide) {
              sendImpression(currentSlide);
            });
        }
        $area.trigger('update.tom.productBoxSlider', [$sliderBox]);
      });
    }
  }
};

//
// URLのクエリを分解する
// @params String queryString クエリ文字列
// @return Object 分解結果のハッシュ
// @see http://stackoverflow.com/questions/11671400/navigate-route-with-querystring
tom.helper.parseQueryString = function (queryString) {
  var params = {};

  if (queryString) {
    queryString.split(/&/g).forEach(function (el) {
      var aux = el.split('=');
      var val = void 0;

      if (aux.length === 2) {
        val = decodeURIComponent(aux[1]);
      }

      params[decodeURIComponent(aux[0])] = val;
    });
  }
  return params;
};

tom.helper.filterImageSrc = function (src) {
  if (tom.user && tom.user.isWebpAgent) {
    return src.replace(tom.user.webpRegExp, '$&.webp');
  } else {
    return src;
  }
};

(function ($) {
  var secondsScore = [
    {
      v: 'less',
      min: 0,
      max: 86400
    },
    {
      v: '1 day',
      min: 86400,
      max: 172799
    },
    {
      v: '2 days',
      min: 172800,
      max: 259199
    },
    {
      v: '3 days',
      min: 259200,
      max: 345599
    },
    {
      v: '4 days',
      min: 345600,
      max: 431999
    },
    {
      v: '5 days',
      min: 432000,
      max: 518399
    },
    {
      v: '6 days',
      min: 518400,
      max: 604799
    },
    {
      v: '1 week',
      min: 604800,
      max: 1209599
    },
    {
      v: '2 weeks',
      min: 1209600,
      max: 1814399
    },
    {
      v: '3 weeks',
      min: 1814400,
      max: 2591999
    },
    {
      v: '1 month',
      min: 2592000,
      max: 5183999
    },
    {
      v: '2 months',
      min: 5184000,
      max: 7775999
    },
    {
      v: '3 months',
      min: 7776000,
      max: 10367999
    }
  ];

  var DateConvertTable = {
    ShortMonths: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    LongMonths: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    ShortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    LongDays: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]
  };

  function convertTime(ts) {
    var min = -1;
    var max = secondsScore.length;

    // lint error回避用のループ記法
    // https://eslint.org/docs/rules/no-constant-condition#rule-details
    for (;;) {
      var center = Math.floor((min + max) / 2);
      if (center === min) {
        return 'more';
      }
      var range = secondsScore[center];

      if (ts < range['min']) {
        max = center;
      } else if (range['min'] <= ts && ts <= range['max']) {
        return range['v'];
      } else {
        min = center;
      }
    }
  }

  $.fn.fazyEffect = function () {
    this.each(function () {
      var $self = $(this);
      var $img = $(this).children('a.image').children('img');
      var $text = $(this).children('a.subtitle').children('span');

      var oheight = $img.height();
      var owidth = $img.width();
      var nheight = oheight * 1.1;
      var nwidth = owidth * 1.1;
      var top = (oheight - nheight) / 2;
      var left = (owidth - nwidth) / 2;

      $img.css({
        height: oheight + 'px',
        width: owidth + 'px'
      });

      $self
        .on('mouseenter', function () {
          $img.stop().animate(
            {
              height: nheight + 'px',
              width: nwidth + 'px',
              left: left + 'px',
              top: top + 'px'
            },
            200
          );
          $text.stop().animate(
            {
              fontSize: '14px'
            },
            200
          );
        })
        .on('mouseleave', function () {
          $img.stop().animate(
            {
              left: '0px',
              top: '0px',
              height: oheight + 'px',
              width: owidth + 'px'
            },
            200
          );
          $text.stop().animate(
            {
              fontSize: '12px'
            },
            200
          );
        });
    });
  };

  $.fn.dateFormat = function (options) {
    options = options || {};

    return this.each(function () {
      var $this = $(this);
      var ts;
      if (options.attr) {
        ts = $this.attr(options.attr);
      } else {
        ts = $this.text();
      }
      var nowTs = new Date().getTime();
      var diff = Math.ceil((nowTs - ts) / 1000);
      var timeName = convertTime(diff);

      if (ts == '' || !isFinite(ts)) {
        return;
      }

      if (timeName === 'more') {
        var d = new Date(parseInt(ts));
        var year = d.getFullYear();
        var monthName = DateConvertTable.ShortMonths[d.getMonth()];
        var day = d.getDate();
        return $this.text(monthName + ' ' + day + ' ' + year);
      }

      if (timeName != 'less') {
        return $this.text(timeName + ' ago');
      }

      var hour = diff / 3600;
      if (hour >= 1.0) {
        var suffix = hour >= 2.0 ? ' hours' : ' hour';
        return $this.text(Math.floor(hour) + suffix + ' ago');
      }

      var min = diff / 60;
      if (min >= 1.0) {
        return $this.text(Math.floor(min) + ' minutes ago');
      }

      return $this.text(diff + ' seconds ago');
    });
  };

  // heightLine
  $.fn.heightLine = function () {
    var target = this,
      windowResizeId = Math.random();
    var hl = {
      defaults: {
        maxWidth: 10000,
        minWidth: 0,
        fontSizeCheck: false
      },
      destroy: function () {
        target.css('height', 'auto');
      },
      create: function (options) {
        var maxHeight = 0,
          windowWidth = $(window).width();
        options = $.extend(this.defaults, options);
        if (
          windowWidth <= options.maxWidth &&
          windowWidth >= options.minWidth
        ) {
          target
            .each(function () {
              if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight();
              }
            })
            .each(function () {
              var height = maxHeight;
              //- parseInt($(this).css("padding-top"))
              //- parseInt($(this).css("padding-bottom"));
              $(this).height(height);
            });
        }
      },
      refresh: function (options) {
        this.destroy();
        this.create(options);
      },
      removeEvent: function () {
        $(window).off('resize.' + windowResizeId);
        target.off('destroy refresh');
      }
    };
    var a = arguments[0];
    if (typeof a === 'string' && a === 'destroy') {
      target.trigger('destroy');
    } else if (typeof a === 'string' && a === 'refresh') {
      target.trigger('refresh');
    } else {
      hl.create(a);

      $(window).on('resize.' + windowResizeId, function () {
        hl.refresh();
      });

      target
        .on('destroy', function () {
          hl.removeEvent();
          hl.destroy();
        })
        .on('refresh', function () {
          hl.refresh();
        });
    }
    return target;
  };
})(jQuery);

(function () {
  // tomSearchBox
  $.fn.tomSearchBox = function (options) {
    return this.each(function () {
      var w = window;
      var $el = $(this);
      var o = $.extend({}, $.fn.tomSearchBox.defaults, options);
      var $keywordField = $el.find(o.field);
      var $submitBtn = $el.find(o.searchBtn);
      var $form = $el.find(o.form);
      var $selectCategoryArea = $form.find(o.category.area);
      var $selectCategoryValue = $selectCategoryArea.find(o.category.value);
      var $selectCategoryMain = $selectCategoryArea.find(o.category.select);
      var isModeShop = $form.data('mode') === 'shop';
      var isHeaderSearchBox = $selectCategoryMain.is(
        '#header-searchBox-category'
      );
      var timer;

      var activeSubmitBtn = function (evt, is_keyword_change) {
        clearTimeout(timer);

        timer = setTimeout(function () {
          var val = evt.target.value.trim();
          var is_active = $el.hasClass(o.class.active);

          if (val || !is_keyword_change) {
            if (is_active === false) {
              $el.addClass(o.class.active);
              $submitBtn.removeAttr('disabled').removeClass(o.class.disabled);
            }
          } else if (is_active === true) {
            $el.removeClass(o.class.active);
            $submitBtn.attr('disabled', 'disabled').addClass(o.class.disabled);
          }
        }, 100);
      };

      // キーワードフィールド部分のイベントハンドラを設定
      $keywordField
        .on('focus', function () {
          $el.addClass(o.class.focus);
        })
        .on('blur', function () {
          $el.removeClass(o.class.focus);
        })
        .on('change keyup', function (evt) {
          activeSubmitBtn(evt, true);
        });

      // カテゴリ選択部分のイベントハンドラを設定
      $selectCategoryMain.on('change', function (evt) {
        var label = $selectCategoryMain.find('option:selected').text();
        $selectCategoryValue.text(label);
        $keywordField.trigger('focus');
        activeSubmitBtn(evt, false);
      });

      // Shop検索画面のヘッダー内検索ボックスでのみ実行される
      if (
        isModeShop &&
        isHeaderSearchBox &&
        w.vueEventBus &&
        w.vueEventBus.search
      ) {
        w.vueEventBus.search.$on('changeSearchParam', function (searchInfo) {
          $keywordField.val(searchInfo.keyword);
          $selectCategoryMain.val(searchInfo.category);
          $selectCategoryValue.text(
            $selectCategoryMain.find('option:selected').text()
          );
        });
      }

      // submit form
      $form.on('submit', function (evt) {
        // submitボタンがdisabledの場合は何もしない
        if ($submitBtn.hasClass(o.class.disabled)) {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }

        // Shop検索画面のヘッダー内検索ボックスでのみ実行される
        if (
          isModeShop &&
          isHeaderSearchBox &&
          w.vueEventBus &&
          w.vueEventBus.search
        ) {
          evt.preventDefault();
          evt.stopPropagation();

          w.vueEventBus.search.$emit('changeSearchParamOutside', {
            keyword: $keywordField.val(),
            category: $selectCategoryMain.val()
          });
        }
      });
    });
  };
  $.fn.tomSearchBox.defaults = {
    class: {
      focus: 'focus',
      active: 'active',
      disabled: 'disabled'
    },
    form: 'form',
    searchBtn: '.searchBtn',
    field: '.searchField',
    category: {
      area: '.selectCategory',
      value: '.selectValue',
      select: 'select'
    }
  };

  // tomSelectBox
  $.fn.tomSelectBox = function (options) {
    return this.each(function () {
      var $el = $(this);
      var o = $.extend({}, $.fn.tomSelectBox.defaults, options);

      !(function () {
        var $display = $el.find(o.value);
        var $select = $el.find(o.select);
        // init
        $display.text($select.find('option:selected').text());
        // add Event
        $select.on('change', function (evt) {
          var label = $select.find('option:selected').text();
          $display.text(label);
          if (typeof o.callBack === 'function') {
            o.callBack(evt.target.value);
          }
        });
      })();
    });
  };
  $.fn.tomSelectBox.defaults = {
    value: '.selectValue',
    select: 'select',
    callBack: null
  };
})();

$(function () {
  var $w = $(window);
  var $d = $(document);
  var $body = $('body');
  var isShownBackTop = false;
  var postfix = '_on';

  // 右クリック禁止
  $d.on('contextmenu', '.nomenu', function () {
    return false;
  }).on('click', '#backTop', function () {
    tom.helper.ga.push(['event', 'Navi', 'Clicked', 'BackToTop', 1]);
    $('body,html').animate(
      {
        scrollTop: 0
      },
      'slow'
    );
    return false;
  });

  tom.helper.disableDrag('.nodraggable');

  $w.on('scroll', function () {
    var scrollTop = $w.scrollTop();
    var $backTop = $('#backTop');
    if (isShownBackTop === false && scrollTop > 700) {
      $backTop.fadeIn(150);
      isShownBackTop = true;
    } else if (isShownBackTop === true && scrollTop <= 700) {
      $backTop.hide();
      isShownBackTop = false;
    }
  });

  $('.linkBtn')
    .not('[src*="' + postfix + '."]')
    .each(function (i, elm) {
      var $img = $(elm);
      var src = $img.attr('src');
      var src_on =
        src.substr(0, src.lastIndexOf('.')) +
        postfix +
        src.substring(src.lastIndexOf('.'));
      $('<img>').attr('src', src_on);
      $img
        .on('mouseenter', function () {
          $img.attr('src', src_on);
        })
        .on('mouseleave', function () {
          $img.attr('src', src);
        });
    });

  (function () {
    var mouseEnterListener = function (evt) {
      var $that = evt.data.$t;
      var $ul = $that.data('menu');
      $that.off('mouseenter', mouseEnterListener);
      $ul.slideDown('fast');
    };
  })();

  $('time.format').dateFormat({ attr: 'data-ts' });
  tom.helper.draggable();

  // search
  // 検索画面（カテゴリ画面）はVueで生成されるコンテンツと連携させるために
  // pugのインラインスクリプトから実行する
  if (!(window.vueEventBus && window.vueEventBus.search)) {
    $('.js-searchBox').tomSearchBox();
  }
});

// For IE
$.ajaxSetup({
  cache: false,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
});
